import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Google Analytics 4 route tracker.
 *
 * The base gtag.js tag lives in public/index.html and fires the first
 * page_view automatically on initial load. This component reports each
 * subsequent client-side navigation (React Router route change) as a
 * page_view so analytics covers every page in the SPA. Renders nothing.
 */
const AnalyticsTracker = () => {
  const location = useLocation();
  const isInitialLoad = useRef(true);

  useEffect(() => {
    // Skip the first render — gtag('config', ...) in index.html already
    // sent the initial page_view, so reporting it here would double-count.
    if (isInitialLoad.current) {
      isInitialLoad.current = false;
      return;
    }

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search + location.hash,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [location]);

  return null;
};

export default AnalyticsTracker;
